import { WeightClassResponseDto, WeightClassesApi } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'
import { Event, IEvent, IQueryHandler, IQueryMessage } from '@tom-ui/utils'

export class GetWeightClassesQuery implements IQueryMessage {
  static type = 'GetWeightClassesQuery'
  type = GetWeightClassesQuery.type

  getKey = () => {
    return JSON.stringify(this)
  }
}

const httpClient = createApiClient(WeightClassesApi)

export const getWeightClassesQueryHandler: IQueryHandler<
  GetWeightClassesQuery,
  IEvent<WeightClassResponseDto[]>
> = async _ => {
  const { data } = await httpClient.get()

  return new Event(GetWeightClassesQuery.type, data)
}
